import { useMemo } from "react"

import ClickableNameList from "#blocks/ClickableNameList"
import { type Uuid } from "#customTypes/globalTypes"
import { useGetSomeUsers } from "#hooks/newHooks/useGetUser"
import { formatTeachers } from "#utils/textFormatters"

const AddClassTeacherList = ({
  onTeacherClick,
  teacherIds,
}: {
  onTeacherClick: (teacherId: Uuid) => void
  teacherIds: Uuid[]
}) => {
  const teachersFromDb = useGetSomeUsers(teacherIds)
  const teachersForDisplay = useMemo(() => {
    return formatTeachers(teachersFromDb)
  }, [teachersFromDb])

  return (
    <ClickableNameList
      namesForDisplay={teachersForDisplay}
      onClick={onTeacherClick}
      columns={1}
    />
  )
}

export default AddClassTeacherList
